import React from "react";
import { TID } from "../../lib/testIds";

const OUTCOMES = [
  "Launch AI capabilities faster",
  "Accelerate product roadmaps",
  "Reduce engineering bottlenecks",
  "Modernize legacy platforms incrementally",
  "Automate repetitive operations",
  "Improve platform scalability",
  "Strengthen delivery capacity",
  "Connect fragmented systems",
  "Turn prototypes into production",
  "Build a stronger foundation for growth",
];

const Row = ({ items, reverse = false, slow = false }) => (
  <div className="flex overflow-hidden">
    <div
      className={`flex shrink-0 ${slow ? "animate-marquee-slow" : "animate-marquee"} ${
        reverse ? "[animation-direction:reverse]" : ""
      }`}
    >
      {[...items, ...items].map((t, i) => (
        <div key={i} className="flex items-center gap-6 px-8 shrink-0">
          <span className="font-headings text-3xl md:text-5xl lg:text-6xl font-black tracking-tight text-white/25 whitespace-nowrap">
            {t}
          </span>
          <span className="w-2 h-2 rotate-45 bg-[#FF5F1F]" />
        </div>
      ))}
    </div>
  </div>
);

export const OutcomesMarquee = () => {
  return (
    <section
      data-testid={TID.outcomesMarquee}
      className="relative py-20 md:py-28 bg-[#0A0A0A] border-y border-white/10 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 mb-10 md:mb-14">
        <div className="flex items-center gap-3 mb-4">
          <div className="h-px w-8 bg-[#FF5F1F]" />
          <span className="font-mono text-[10px] md:text-xs uppercase tracking-[0.25em] text-[#FF5F1F]">
            What Changes
          </span>
        </div>
        <h2 className="font-headings text-3xl md:text-5xl lg:text-6xl font-black tracking-tight leading-[1.05] text-white max-w-3xl">
          Engineering That Moves the Business Forward
        </h2>
      </div>

      <div className="space-y-4 md:space-y-6">
        <Row items={OUTCOMES} />
        <Row items={[...OUTCOMES].reverse()} reverse slow />
      </div>
    </section>
  );
};
